// ----------------------------------------------------------------------------
// Component: Product Specs
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_specs-table.scss';